import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { MapState } from '../../map/reducer';
import { useParams } from 'react-router-dom';
import { MEDLEM_ID_PATTERN } from '../../../../utils';
import { UseParams } from '../../../../types';
import SubmitReport from '../../submit-report/components/submit-report';
import PageWithSidebar from '../../../../features/list-page-with-filter/components/page-with-sidebar';
import DetailPage from '../components/detail-page';

export default function DetailPageContainer(): ReactElement {
  const { slug }: UseParams = useParams();
  const { objects } = useSelector((state: { map: MapState }) => ({
    objects: state.map.objects,
  }));
  const portAndWaterwayObject = objects.find((i) => i.id === slug);

  if (!portAndWaterwayObject) {
    return null;
  }

  if (MEDLEM_ID_PATTERN.test(portAndWaterwayObject?.id)) {
    return (
      <PageWithSidebar
        sideBar={<SubmitReport id={parseInt(portAndWaterwayObject.id.substring(1), 10)} />}
        mainContent={<DetailPage portAndWaterwayObject={portAndWaterwayObject} />}
      />
    );
  }
  return <DetailPage />;
}
